/*
  example:
    import { getWorkOrderTypes } from '@/services/WorkOrders/WorkOrderType/List';

    const { list, message, successful } = await getWorkOrderTypes ();
    if (!successful) {
      console.error (message);
      return;
    }
*/
//
import _get from 'lodash/get'
//
import kms from '@/services/kms'
//
export async function getWorkOrderTypes({ kms: kms_ = kms, params = {} } = {}) {
  const message = 'The work order types list could not be retrieved.'

  try {
    const result = await kms_.get(`/WorkOrders/WorkOrderType/List`, {
      params
    })

    let list = _get(result, 'results', [])
    if (!Array.isArray(list)) {
      list = []
    }

    return {
      successful: true,
      list,
      message: ''
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    list: [],
    successful: false,
    message
  }
}

///////
